<template>
  <form>
    <div class="row">
      <div class="col-sm-12 row">
        <div class="card-body">

          <div class="row">
            <div class="col-4">
              <TextField 
                :placeholder="$t('user.form.first_name.placeholder')"
                :label="$t('user.form.first_name.label')"
                v-model="model.first_name"
                :error="$v.model.first_name.$error"
                :errorMessage="$v.model.first_name.errorMessage"
              />
            </div>

            <div class="col-4">
              <TextField 
                :placeholder="$t('user.form.middle_name.placeholder')"
                :label="$t('user.form.middle_name.label')"
                v-model="model.middle_name"
              />
            </div>

            <div class="col-4">
              <TextField 
                :placeholder="$t('user.form.last_name.placeholder')"
                :label="$t('user.form.last_name.label')"
                v-model="model.last_name"
                :error="$v.model.last_name.$error"
                :errorMessage="$v.model.last_name.errorMessage"
              />
            </div>
            <div class="col-4">
              <TextField 
                :placeholder="$t('candidate.form.jp_first_name.placeholder')"
                :label="$t('candidate.form.jp_first_name.label')"
                v-model="model.first_name_kana"
              />
            </div>

            <div class="col-4">
              <TextField 
                :placeholder="$t('candidate.form.jp_middle_name.placeholder')"
                :label="$t('candidate.form.jp_middle_name..label')"
                v-model="model.middle_name_kana"
              />
            </div>

            <div class="col-4">
              <TextField 
                :placeholder="$t('candidate.form.jp_last_name.placeholder')"
                :label="$t('candidate.form.jp_last_name.label')"
                v-model="model.last_name_kana"
              />
            </div>
            
            <div class="col-4">
              <TextField 
                placeholder="hello@hrtech.com"
                :label="$t('user.form.email.label')"
                type="email"
                autocomplete="off"
                v-model="model.email"
                :error="$v.model.email.$error"
                :errorMessage="$v.model.email.errorMessage"
              />
            </div>
            <div class="col-4">
              <DropDown 
                :placeholder="$t('candidate.form.gender.placeholder')"
                :label="$t('candidate.form.gender.label')"
                :name.sync="model.gender"
                v-model="model.gender"
                :options="genderOption"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import TextField from '@components/form/textfield.vue'
import DropDown from '@components/form/dropdown.vue'
import  FormMixin from '@mixins/form'

import { required, email } from 'vuelidate/lib/validators'

export default {
  components: {
    TextField,
    DropDown
  },
  mixins: [ FormMixin ],
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  validations: {
    model:{
      first_name: { 
        required
      },
      last_name: { 
        required
      },
      email: {
        required,
        email
      },
      gender: {
        required
      }
    }
  },
  data () {
    return {
      model:{
        first_name: '',
        middle_name:'',
        last_name: '',
        first_name_kana: '',
        middle_name_kana:'',
        last_name_kana: '',
        email: '',
        gender: ''
      },
      genderOption: [
        {value: 'MALE', text: 'MALE'},
        {value: 'FEMALE', text: 'FEMALE'},
        {value: 'OTHER', text: 'OTHER'}
      ],
    }
  },
  computed: {
    submitted() {
      let parameters = this.parameters || {}
      return parameters.submitted
    }
  },
  watch: {
    submitted: function () {
      this.model = {
        first_name: '',
        middle_name:'',
        last_name: '',
        first_name_kana: '',
        middle_name_kana:'',
        last_name_kana: '',
        email: '',
        gender: ''
      }
    }
  }
}
</script>